export const baseURL = `${process.env.REACT_APP_API_BASE}/`;

export const terms = ["Summer", "Fall", "Winter", "Spring"] as const;

export const toAcademicYear = (year: number, connector = "-") => {
  const input = year.toString();
  if (!Number.isInteger(year) || input.length !== 4 || year < 0) return year;
  return `${year}${connector}${Number(input.substring(2)) + 1}`;
};
